import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if @value}}\n  {{#if (has-block)}}\n    {{yield}}\n  {{else}}\n    {{@value}}\n  {{/if}}\n{{else}}\n  <span class=\"empty-dash\">\u2014</span>\n{{/if}}", {
  moduleName: "ui-kit/components/dash-if-empty/index.hbs"
});